import { useSetAtom } from 'jotai';
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncLocationAtom } from '@/atoms/location';

export const useSyncLocationAtom = () => {
  const location = useLocation();
  const syncLocation = useSetAtom(syncLocationAtom);

  useLayoutEffect(() => {
    syncLocation({
      pathname: location.pathname,
      searchParams: new URLSearchParams(location.search),
      hash: location.hash,
    });
  }, [location.pathname, location.search, location.hash]);
};
